<template>
    <div class="section pt-0">
        <transition-group
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0"
            appear
        >
            <router-link
                v-if="showCreationCard"
                :key="'creationCard'"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-desktop is-3-widescreen
                    lb-project-card lb-creation-object
                "
                :to="{
                    path: '/creation',
                    query: {
                        folder: this.$route.params.folder,
                    },
                }"
            >
                <div class="lb-project-box has-background-info-light">
                    <div
                        class="
                            columns
                            is-multiline is-mobile is-marginless
                            has-background-info-light
                        "
                    >
                        <div
                            class="
                                column
                                is-full
                                has-text-centered
                                has-text-weight-bold
                                has-text-primary
                            "
                        >
                            <span class="icon is-large">
                                <i
                                    class="
                                        mdi mdi-10r mdi-plus-circle-outline
                                        pt-5
                                    "
                                    aria-hidden="true"
                                />
                            </span>
                        </div>
                        <div
                            class="
                                column
                                is-full
                                has-text-centered has-text-weight-bold
                            "
                        >
                            <p
                                class="
                                    is-size-5
                                    lb-card-title
                                    is-block
                                    has-text-primary
                                "
                            >
                                {{ $t('creation.new_project') }}
                            </p>
                        </div>
                    </div>
                </div>
            </router-link>

            <div
                v-for="project in projects"
                :key="project._id"
                :to="{ name: 'project', params: { projectId: project._id } }"
                tag="div"
                draggable="true"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-desktop is-3-widescreen
                    lb-project-card
                "
                @dragstart="dragStart($event, project)"
                @dragenter.prevent
                @dragover.prevent
                @click="selectProject(project)"
            >
                <project-card
                    :content="project"
                    @delete="deleteProject(project)"
                    @removeFromFolder="removeProjectFromFolder(project)"
                    @show-share-modal="openShareModal(project)"
                    @view="viewProject(project)"
                />
            </div>
        </transition-group>

        <project-modal-share
            v-if="showShareModal"
            :content="project"
            @close="showShareModal = false"
        ></project-modal-share>
       
    </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard';
import ProjectModalShare from '@/components/ProjectModalShare';
import { deleteItem, removeProjectFromFolder } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        ProjectCard,
        ProjectModalShare
    },
    props: {
        projects: {
            type: Array,
            default() {
                return [];
            },
        },
        showCreationCard: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            showShareModal: false,
            project: null,
        };
    },
    methods: {
        selectProject(project) {
            // this.showModal = true;
            this.project = project;
            if(this.project.accessLevel && this.project.accessLevel!='read'){
                this.$router.push({
                    name: 'project',
                    params: { projectId: this.project._id },
                });
            }else{
                /*if(this.project.mode && this.project.mode=='map'){
                    this.$router.push({
                        name: 'project-view',
                        params: { projectId: this.project._id },
                    });
                }else{*/
                    this.$router.push({
                        name: 'project',
                        params: { projectId: this.project._id },
                    });
                // }
            }
        },
        viewProject(project) {
            this.project = project;
            if(this.project.mode && this.project.mode=='map'){
                    this.$router.push({
                        name: 'project-view',
                        params: { projectId: this.project._id },
                    });
                }else{
                    this.$router.push({
                        name: 'project',
                        params: { projectId: this.project._id },
                    });
                }
        },
        async deleteProject(item) {
            if (confirm(this.$t('delete_project_confirmation_message'))) {
                let response = await deleteItem('project', item._id);
                if (response.data.success) {
                    this.$emit('deleteProject', item._id);
                } else {
                    console.error('impossible to delete project');
                }
            }
        },
        async removeProjectFromFolder(project) {
            const projectIndex = _.findIndex(this.projects, {
                _id: project._id,
            });
            const splicedProject = this.projects.splice(projectIndex, 1);
            removeProjectFromFolder(project.folder, {
                project: project._id,
            }).catch(() => {
                this.projects.splice(projectIndex, 0, splicedProject[0]);
            });
        },
        dragStart(ev, project) {
            ev.dataTransfer.setData('project', project._id);
        },
        openShareModal(project){
            this.project = project;
            this.showShareModal = true;
        }
    },
};
</script>

<style scoped>
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}
</style>
